import { TooltipHost } from "@fluentui/react";
import classNames from "classnames";
import React from "react";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import "./ContentWithTooltip.scss";

interface IProps {
    tooltip: string;
    children?: any;
    className?: string;
}

const ContentWithTooltip = (props: IProps) => {
    return (
        <div className={classNames("ContentWithTooltip", props.className)}>
            {props.children}
            <TooltipHost
                className="marketplace-tooltip"
                content={props.tooltip}
                style={{
                    maxWidth: 300
                }}
            >
                <Visage2Icon icon="info-circle" size="small" />
            </TooltipHost>
        </div>
    )
}

export default ContentWithTooltip;
